import DislikeSignalModal from './DislikeSignalModal.component';

export default DislikeSignalModal;
